/* istanbul ignore file */

import { useThree } from '@react-three/fiber';
import { useEffect } from 'react';

export const ThumbnailGenerator = ({
  onModelThumbnailGenerate,
}: {
  onModelThumbnailGenerate: (thumbnail: string) => void;
}) => {
  const { gl } = useThree();

  useEffect(() => {
    const createThumbnail = () => {
      setTimeout(() => {
        const thumbnailString = gl.domElement.toDataURL().split(';base64,')[1];
        onModelThumbnailGenerate(thumbnailString);
      }, 1000); // Wait for the animation to finish before generating the thumbnail
    };

    createThumbnail();
  }, [gl, onModelThumbnailGenerate]);

  return null;
};
